import React , {useState} from 'react';
import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { UserContext } from "./components/AuthComponents/UserContext";
import PublicLayout from './components/Publiclayout';
import Home from './views/home';
import RegistrationForm from './views/RegistrationForm';
import PrivateLayout from './components/PrivateLayout';
import UserHome from './components/AuthComponents/UserHome';
import UserResetPassword from './components/AuthComponents/ChangePassword/UserPasswordChange2';
import UpdateProfile from './components/AuthComponents/UserUpdateProfile/UpdateProfile';
import UserIPwhitelist from './components/AuthComponents/IPWhitelisting/UserIPwhitelist';
import CostSummary from './components/AuthComponents/TxnCostSummary/CostSummary';
import Txnsummary from './components/AuthComponents/Dashboard2';
import ResetPassword from './components/ResetPassword';
import RegistrationConfirm from './components/Home/RegistrationConfirm';
import FAQMore from './components/FAQMore';
import AccessibilityOld from './Accessibility_TSX';
import Chatbot from './components/Chatbot/Chatbot2';
import UserDashboard from './components/AuthComponents/Dashboard2';
import IntegrationStatus from './components/AuthComponents/IntegrationStatus';

import Accessibility from '../src/components/Accessibility';
import { AccessibilityProvider }  from './context/AccessibilityProvider';
import '../src/styles/accessibility2.css';
import NewTicket from './components/AuthComponents/eTicketing/NewTicket';
import ViewTickets from './components/AuthComponents/eTicketing/ViewTickets';
import { Provider } from 'react-redux';
import { store } from './store/store';


function App() {
  const [username, setUsername] = useState("");
  
  return (
    
    <AccessibilityProvider>
    <UserContext.Provider value={{ username, setUsername }}>
      <div id="app-content">
        <Routes>
          {/* Public routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/registrationform" element={<RegistrationForm />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/registrationConfirm" element={<RegistrationConfirm />} />
            <Route path="/faq" element={<FAQMore />} />
          
          </Route>

          {/* Private routes */}
          
          <Route  element={
      <Provider store={store}>
        <PrivateLayout />
      </Provider>
    }>
            <Route path="/user/homepage" element={<UserHome />} />
            <Route path="/user/resetPassword" element={<UserResetPassword />} />
            <Route path="/user/update_profile" element={<UpdateProfile />} />
            <Route path="/user/ipwhitelisting" element={<UserIPwhitelist />} />
            <Route path="/user/txnsummary" element={<Txnsummary />} />
            <Route path="/user/cost_summary" element={<CostSummary />} />
            <Route path="/user/dashboard" element={<UserDashboard />} />
            <Route path="/user/status" element={<IntegrationStatus />} />
            <Route path="/user/newTicket" element={<NewTicket />} />
            {<Route path="/user/viewTicket" element={<ViewTickets />} /> }
      {/* e-Ticketing Components */}
            
          </Route>

        </Routes>
      </div>
      {/* <Accessibility /> */}
      <AccessibilityOld />
      {/* <Chatbot /> */}
    </UserContext.Provider>
    </AccessibilityProvider>
    
  );
}

export default App;
